// src/components/Groups/CreateGroupModal.jsx
import React, { useState } from "react";
import { toast } from "react-toastify";

const CreateGroupModal = ({ isOpen, onClose, onCreate }) => {
  const [groupName, setGroupName] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    const trimmedName = groupName.trim();
    if (!trimmedName) return;

    const newGroup = {
      name: trimmedName,
      id: Date.now(),
      description: "",
    };

    onCreate(newGroup);
    toast.success("Group created successfully");
    setGroupName("");
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white dark:bg-gray-900 p-6 rounded-md w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4 text-gray-800 dark:text-white">Create New Group</h2>
        <input
          type="text"
          placeholder="Group name"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          className="w-full px-4 py-2 border rounded mb-4 dark:bg-gray-700 dark:text-white"
        />
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 dark:bg-gray-700 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
          <button
            onClick={handleCreate}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateGroupModal;
